import { React, useEffect, useState, useContext } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../contexts/authContext";

import { Button, Loader } from '@mantine/core';

import LogoNavbar from "../../../composents/Logo/NavbarLogo/Logo";

const PaymentSucceed = () => {
    const { getToken } = useContext(AuthContext);  
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 
    
    const [transaction, setTransaction] = useState(null);
    const [loading, setLoading] = useState(true);

    const reference = searchParams.get("ref");
    console.log(reference)
    
   useEffect(() => {
    const token = getToken();
    if (!token) {
        navigate("/app/login");
        return;
    }

    if (!reference) {
        setLoading(false);
        return;
    }

    const fetchTransaction = async () => {
        try {
        const res = await fetch(
            `https://boldee-97d8d36af3bd.herokuapp.com/app/payment/by-reference/${reference}`,
            {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
            credentials: "include"
            }
        );
        if (!res.ok) {
            const err = await res.json();
            console.error("Erreur backend:", err.message);
            return;
            }

            const data = await res.json();
            console.log("transaction data:", data);
            setTransaction(data);
        } catch (err) {
        console.error(err);
        } finally {
        setLoading(false);
        }
    };

    fetchTransaction();

    }, [reference, navigate, getToken]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) return <div className="loaderWrapper vertical">
                <Loader color="green" size="sm" type="dots" />
                <div className='mrgT5'>Vérification du paiement ...</div>
            </div>;

    if (!transaction) {
        return (
            <div className="loaderWrapper vertical">
                <Loader color="green" size="sm" type="dots" />
                <p className='mrgT5'>Paiement en cours de vérification...</p>
                <p>Si le problème persiste, contactez le support.</p>
            </div>
        );
    }


    return(
        <>
        {isMobile ? (
            <div className="width95pCenter">
                <LogoNavbar />

                {transaction.contrat === "Don" ? (
                    <>
                        <h3>✅ Demande de don envoyée</h3>
                        <div className="bLiteGrey">
                            <div className="width90pCenter">
                                <p className="padT20"><strong>Référence :</strong> {transaction.reference}</p>
                                <p><strong>Don :</strong> {transaction.title}</p>
                                <p><strong>Donateur :</strong> {transaction.provider}</p>
                            </div>
                            <div className="width90pCenter">
                                <p>
                                    Votre demande a bien été envoyée au donateur. Il dispose de 72 heures (jours ouvrables) pour accepter ou refuser votre demande.
                                </p>
                                <p className="padB20">
                                    Vous serez notifié directement via la messagerie de boldee.
                                </p>
                            </div>
                        </div>
                    </>
                ) : transaction.contrat === "Location" ? (
                    <>
                        <h3>✅ Réservation confirmée</h3>
                        <div className="bLiteGrey">
                            <div className="width90pCenter">
                                <p className="padT20"><strong>Référence :</strong> {transaction.reference}</p>
                                <p><strong>Location :</strong> {transaction.title}</p>
                                <p>
                                    <strong>Période :</strong>{" "}
                                    {transaction.startDate ? new Date(transaction.startDate).toLocaleDateString("fr-FR") : ""} — {transaction.endDate ? new Date(transaction.endDate).toLocaleDateString("fr-FR") : ""}
                                </p>
                                <p>
                                    <strong>Montant :</strong>{" "}
                                    {(transaction.amount / 100).toFixed(2)} € (frais de services et de TVA inclus)
                                </p>
                                <p><strong>Prestataire :</strong> {transaction.provider}</p>
                                <p><strong>Statut :</strong> Fonds sécurisés</p>
                            </div>
                            <div className="width90pCenter">
                                <p>
                                    Le prestataire dispose de 72 heures (jours ouvrables) pour confirmer votre réservation.
                                </p>
                                <p>
                                    Il vous contactera directement via la messagerie de boldee.
                                </p>
                                <p className="padB20">
                                    Les fonds sont sécurisés par la plateforme et ne seront versés au prestataire qu’après validation de la location.
                                </p>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <h3>✅ Paiement sécurisé confirmé</h3>
                        <div className="bLiteGrey">
                            <div className="width90pCenter">
                                <p className="padT20"><strong>Référence :</strong> {transaction.reference}</p>
                                <p><strong>Titre :</strong> {transaction.title}</p>
                                <p>
                                    <strong>Montant :</strong>{" "}
                                    {(transaction.amount / 100).toFixed(2)} € (frais de services et de TVA inclus)
                                </p>
                                <p><strong>Prestataire :</strong> {transaction.provider}</p>
                                <p><strong>Statut :</strong> Fonds sécurisés</p>
                            </div>
                            <div className="width90pCenter">
                                <p>
                                    Le prestataire dispose de 72 heures (jours ouvrables) pour confirmer la prise en charge de votre demande.
                                </p>
                                <p>
                                    Il vous contactera directement via la messagerie de boldee afin d’organiser la prestation.
                                </p>
                                <p className="padB20">
                                    Les fonds sont sécurisés par la plateforme et ne seront versés au prestataire qu’après validation de la prestation.
                                </p>
                            </div>
                        </div>
                    </>
                )}

                <Button
                    className="w100"
                    color="green"
                    onClick={() => navigate("/app/research/list")}
                >
                    Retour application
                </Button>
            </div>
        ) : (
            <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#ececec" }}>
            <div style={{ width: 520, maxWidth: "90%", backgroundColor: "#fff", borderRadius: 12, boxShadow: "0 2px 12px rgba(0,0,0,0.08)", padding: "32px", boxSizing: "border-box" }}>
                <LogoNavbar />

                {transaction.contrat === "Don" ? (
                    <>
                        <h3>✅ Demande de don envoyée</h3>
                        <div className="bLiteGrey">
                            <div className="width90pCenter">
                                <p className="padT20"><strong>Référence :</strong> {transaction.reference}</p>
                                <p><strong>Don :</strong> {transaction.title}</p>
                                <p><strong>Donateur :</strong> {transaction.provider}</p>
                            </div>
                            <div className="width90pCenter">
                                <p>
                                    Votre demande a bien été envoyée au donateur. Il dispose de 72 heures (jours ouvrables) pour accepter ou refuser votre demande.
                                </p>
                                <p className="padB20">
                                    Vous serez notifié directement via la messagerie de boldee.
                                </p>
                            </div>
                        </div>
                    </>
                ) : transaction.contrat === "Location" ? (
                    <>
                        <h3>✅ Réservation confirmée</h3>
                        <div className="bLiteGrey">
                            <div className="width90pCenter">
                                <p className="padT20"><strong>Référence :</strong> {transaction.reference}</p>
                                <p><strong>Location :</strong> {transaction.title}</p>
                                <p>
                                    <strong>Période :</strong>{" "}
                                    {transaction.startDate ? new Date(transaction.startDate).toLocaleDateString("fr-FR") : ""} — {transaction.endDate ? new Date(transaction.endDate).toLocaleDateString("fr-FR") : ""}
                                </p>
                                <p>
                                    <strong>Montant :</strong>{" "}
                                    {(transaction.amount / 100).toFixed(2)} € (frais de services et de TVA inclus)
                                </p>
                                <p><strong>Prestataire :</strong> {transaction.provider}</p>
                                <p><strong>Statut :</strong> Fonds sécurisés</p>
                            </div>
                            <div className="width90pCenter">
                                <p>
                                    Le prestataire dispose de 72 heures (jours ouvrables) pour confirmer votre réservation.
                                </p>
                                <p>
                                    Il vous contactera directement via la messagerie de boldee.
                                </p>
                                <p className="padB20">
                                    Les fonds sont sécurisés par la plateforme et ne seront versés au prestataire qu’après validation de la location.
                                </p>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <h3>✅ Paiement sécurisé confirmé</h3>
                        <div className="bLiteGrey">
                            <div className="width90pCenter">
                                <p className="padT20"><strong>Référence :</strong> {transaction.reference}</p>
                                <p><strong>Titre :</strong> {transaction.title}</p>
                                <p>
                                    <strong>Montant :</strong>{" "}
                                    {(transaction.amount / 100).toFixed(2)} € (frais de services et de TVA inclus)
                                </p>
                                <p><strong>Prestataire :</strong> {transaction.provider}</p>
                                <p><strong>Statut :</strong> Fonds sécurisés</p>
                            </div>
                            <div className="width90pCenter">
                                <p>
                                    Le prestataire dispose de 72 heures (jours ouvrables) pour confirmer la prise en charge de votre demande.
                                </p>
                                <p>
                                    Il vous contactera directement via la messagerie de boldee afin d’organiser la prestation.
                                </p>
                                <p className="padB20">
                                    Les fonds sont sécurisés par la plateforme et ne seront versés au prestataire qu’après validation de la prestation.
                                </p>
                            </div>
                        </div>
                    </>
                )}

                <Button
                    className="w100"
                    color="green"
                    onClick={() => navigate("/app/research/list")}
                >
                    Retour application
                </Button>
            </div>
            </div>
        )}
        </>
    )
};

export default PaymentSucceed;